import { render, staticRenderFns } from "./distributorpurchaseinboundreporttable.vue?vue&type=template&id=8706dd6c&scoped=true&"
import script from "./distributorpurchaseinboundreporttable.vue?vue&type=script&lang=js&"
export * from "./distributorpurchaseinboundreporttable.vue?vue&type=script&lang=js&"
import style0 from "./distributorpurchaseinboundreporttable.vue?vue&type=style&index=0&id=8706dd6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8706dd6c",
  null
  
)

export default component.exports